import React, { useState, useEffect } from "react";
import { useSelector, shallowEqual } from "react-redux";

import FooterContentFunc from "./footerContent";
import AnchorElement from "../../functions/AnchorElement.jsx";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

import FacebookIcon from "../../assets/img/nbs/facebook.svg";
import TwitterIcon from "../../assets/img/nbs/twitter.svg";
import LinkedinIcon from "../../assets/img/nbs/linkedin.svg";
import YoutubeIcon from "../../assets/img/nbs/youtube.svg";

import HeaderShopImg from "../../assets/img/nbs/Shop_White_E.svg";
import LogoWhite from "../../assets/img/nbs/Logo_White.svg";

import { I18nContext } from "../../i18n/index";
import { REDIRECT_KEYS, REDIRECT_SCP } from "../../redux/links";
function Footer() {
  const data = useStaticQuery(graphql`
    query {
      Logo: file(relativePath: { eq: "logoFoot.png" }) {
        childImageSharp {
          fixed(width: 230) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `);

  const { translate } = React.useContext(I18nContext);

  const langState = useSelector(state => state.mainReducer.lang, shallowEqual);

  const isMobileState = useSelector(
    state => state.mainReducer.isMobile,
    shallowEqual
  );

  const loginNameState = useSelector(
    state => state.loginReducer.loginName,
    shallowEqual
  );

  const [footerContent, setFooterContent] = useState({});

  useEffect(() => {
    setFooterContent(FooterContentFunc(langState, loginNameState));
    return () => {
      setFooterContent({});
    };
  }, [langState]);

  const [activeFooterSection, setActiveFooterSection] = useState("");

  const renderLinks = arrContent => {
    return arrContent.map((content, i) => (
      <li {...content.parent.attributes} key={i}>
        {content.children.map((childContent, i) => {
          return <AnchorElement {...childContent} key={i} />;
        })}
      </li>
    ));
  };

  const finePrint = (
    <small>Copyright © 2021 Bureau en Gros Ltée - Tous droits réservés.</small>
  );
  if (footerContent && Object.keys(footerContent).length > 0) {
    if (isMobileState) {
      const handleOnClickFooterSection = e => {
        const { target: clickedFooterSectionTarget } = e.target.dataset;
        setActiveFooterSection(
          activeFooterSection !== clickedFooterSectionTarget &&
            clickedFooterSectionTarget
        );

        console.info(
          "activeFooterSection",
          activeFooterSection,
          clickedFooterSectionTarget
        );
      };

      const handleWhatIconToDisplay = footerSectionName => {
        return activeFooterSection === footerSectionName
          ? `remove_circle`
          : `add_circle`;
      };
      return (
        <footer style={{ backgroundColor: "rgb(116,118,121)", color: "white" }}>
          {/* <div style={{backgroundColor: "rgb(66, 66, 66)", width:"100%", paddingBottom:"6px",paddingTop:"3px"}}>
                               <div className="h-container-ml" style={{maxWidth:"50%", marginLeft:"auto", marginRight:"auto"}}>        
                                <div className="h-container-ml">
                                    <a href="https://www.staples.ca/">
                                    <img style={{width:"100%", height:"auto", marginTop:"11px"}} src={LogoWhite} alt="Staples Canada" />  
                                    </a>
                                </div>
                              <div className="logo-line-splitter"> </div>   
                                  <div className="h-container-ml">
                                      <a href="https://www.staplescopyandprint.ca/default.aspx">
                                    <img style={{width:"100%", height:"auto", marginTop: "9px"}} src={HeaderShopImg} alt="Print & Marketing Services"/> </a>
                                  </div>           
                                </div>
                             </div> */}

          <div className="new-footer" style={{ maxWidth: "100%" }}>
            <div className="columns " style={{ maxWidth: "100%" }}>
              {/* <div className="footer_Line"> */}
              <div>
                {/* <div className="footerLogo pull-left">
                    <Img
                      fixed={data.Logo.childImageSharp.fixed}
                      alt="Avetti eCommerce Logo"
                    />
                  </div> */}
              </div>
              {/* </div> */}
              {/* Mobile Version */}
              <div
                className="v-container"
                style={{
                  maxWidth: "930px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "flex"
                }}
              >
                {/* <div className="liHead" id="about-menu">
                        {translate("vm.footer.learnmore")}
                        <i
                          className="hidden-md hidden-lg hidden-sm fas fa-plus-circle global--one-column pull-right"
                          id="global--mobile-about-expand"
                        ></i>
                      </div> */}
                <div className="v-container">
                  <div class="h-container-ml" style={{ marginTop: "12px" }}>
                    <div
                      class="h-cont-footer-box"
                      style={{ minWidth: "33.333%" }}
                    >
                      <div
                        class="v-container"
                        style={{
                          minHeight: "90px",
                          minWidth: "33.333%",
                          maxWidth: "33.3333%"
                        }}
                      >
                        <span>Renseignements sur l'entreprise</span>
                        <ul>
                          <li>
                            {" "}
                            <a href={`${REDIRECT_SCP(REDIRECT_KEYS.about)}`}>
                              À propos de nous
                            </a>
                          </li>
                          <li>
                            {" "}
                            <a href={`${REDIRECT_SCP(REDIRECT_KEYS.careers)}`}>
                              Emplois
                            </a>
                          </li>
                          <li>
                            {" "}
                            <a href="http://www.essentialaccessibility.com/staples/copyprint/en?utm_source=staplescopyandprintenhomepage&utm_medium=iconlarge&utm_term=eachannelpage&utm_content=header&utm_campaign=staplescopyandprinten">
                              {" "}
                              Accessibilité
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div class="h-cont-footer-box" style={{}}>
                      <div class="v-container" style={{ minHeight: "90px" }}>
                        <span>Service à la clientèle</span>
                        <ul>
                          <li>
                            {" "}
                            <a
                              href={`${REDIRECT_SCP(REDIRECT_KEYS.priceList)}`}
                            >
                              Prix
                            </a>
                          </li>
                          <li>
                            <a href={`${REDIRECT_SCP(REDIRECT_KEYS.faq)}`}>
                              Foire aux questions
                            </a>
                          </li>
                          <li>
                            {" "}
                            <a
                              href={`${REDIRECT_SCP(REDIRECT_KEYS.priceList)}`}
                            >
                              {" "}
                              Politiques et mentions légales
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div class="h-cont-footer-box" style={{}}>
                      <div class="v-container" style={{ minHeight: "90px" }}>
                        <span>Aide</span>
                        <ul>
                          <li>
                            {" "}
                            <a href={`${REDIRECT_SCP(REDIRECT_KEYS.account)}`}>
                              Mon compte
                            </a>
                          </li>
                          <li>
                            {" "}
                            <a
                              href={`${REDIRECT_SCP(REDIRECT_KEYS.locations)}`}
                            >
                              Trouver un magasin
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REDIRECT_SCP(REDIRECT_KEYS.contactUs)}`}
                            >
                              Contactez-nous
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div
                    class="h-container-ml"
                    style={{ marginBottom: "12px", marginTop: "24px" }}
                  >
                    <div
                      class="h-cont-footer-box"
                      style={{ maxWidth: "33.3333%" }}
                    >
                      <div class="v-container" style={{}}>
                        <span>Air Miles Programme</span>
                        <p>
                          <a>
                            Obtenez des milles de récompense Air Miles
                            <span
                              style={{ fontSize: "50%", verticalAlign: "top" }}
                            >
                              ®†
                            </span>{" "}
                            sur vos achats.
                          </a>
                          <a href={`${REDIRECT_SCP(REDIRECT_KEYS.airMiles)}`}>
                            En savoir plus sur le programme &gt;
                          </a>
                        </p>
                      </div>
                    </div>

                    <div
                      class="h-cont-footer-box"
                      style={{ minHeight: "90px" }}
                    >
                      <div class="v-container" style={{ minHeight: "90px" }}>
                        <span>Joignez-nous sur :</span>
                        <ul>
                          <li>
                            {/* <li>img line</li>  */}
                            <div style={{ height: "36.72px" }}>
                              <div
                                class="footer-mini-images-container"
                                style={{ height: "27px" }}
                              >
                                <a href="https://www.youtube.com/bureauengrostv">
                                  <img src={YoutubeIcon} alt="YouTube" />
                                </a>
                              </div>
                            </div>
                            <a href="https://www.staples.ca/sbdca/fr_CA/cre/programs/email/index.html?icid=HP:HP:STAPLESPRINTFOOTER:EmailSignup:RESP::1">
                              <p>Aubaines! Profitez-en &gt;</p>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div id="finePrint">{finePrint}</div>
            </div>
          </div>
        </footer>
      );
    } else {
      return (
        <div>
          <footer id="footer" style={{ maxHeight: "296px", height: "296px" }}>
            <div className="new-footer" style={{ maxWidth: "100%" }}>
              <div
                className="footer-container"
                style={{
                  maxWidth: "930px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "flex"
                }}
              >
                {/* <div className="liHead" id="about-menu">
                        {translate("vm.footer.learnmore")}
                        <i
                          className="hidden-md hidden-lg hidden-sm fas fa-plus-circle global--one-column pull-right"
                          id="global--mobile-about-expand"
                        ></i>
                      </div> */}

                <div class="h-cont-footer-box">
                  <div class="v-container" style={{ minHeight: "90px" }}>
                    <span>Renseignements sur l'entreprise</span>
                    <ul>
                      <li>
                        {" "}
                        <a href={`${REDIRECT_SCP(REDIRECT_KEYS.about)}`}>
                          À propos de nous
                        </a>
                      </li>
                      <li>
                        {" "}
                        <a href={`${REDIRECT_SCP(REDIRECT_KEYS.careers)}`}>
                          {" "}
                          Emplois
                        </a>
                      </li>
                      <li>
                        <a href="http://www.essentialaccessibility.com/staples/copyprint/en?utm_source=staplescopyandprintenhomepage&utm_medium=iconlarge&utm_term=eachannelpage&utm_content=header&utm_campaign=staplescopyandprinten">
                          Accessibilité
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="h-cont-footer-box">
                  <div
                    class="v-container"
                    style={{ minHeight: "90px", minWidth: "87px" }}
                  >
                    <span>Aide</span>
                    <ul>
                      <li>
                        {" "}
                        <a href={`${REDIRECT_SCP(REDIRECT_KEYS.account)}`}>
                          Mon compte
                        </a>
                      </li>
                      <li>
                        {" "}
                        <a href={`${REDIRECT_SCP(REDIRECT_KEYS.locations)}`}>
                          Trouver un magasin
                        </a>
                      </li>
                      <li>
                        {" "}
                        <a href={`${REDIRECT_SCP(REDIRECT_KEYS.contactUs)}`}>
                          Contactez-nous
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="h-cont-footer-box">
                  <div class="v-container" style={{ minHeight: "90px" }}>
                    <span>Service à la clientèle</span>
                    <ul>
                      <li>
                        {" "}
                        <a href={`${REDIRECT_SCP(REDIRECT_KEYS.priceList)}`}>
                          Prix{" "}
                        </a>
                      </li>
                      <li>
                        {" "}
                        <a href={`${REDIRECT_SCP(REDIRECT_KEYS.faq)}`}>
                          {" "}
                          Foire aux questions
                        </a>
                      </li>
                      <li>
                        <a href={`${REDIRECT_SCP(REDIRECT_KEYS.policy)}`}>
                          {" "}
                          Politiques et mentions légales
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="h-cont-footer-box">
                  <div class="v-container" style={{ minHeight: "90px" }}>
                    <span>Air Miles Programme</span>
                    <ul>
                      <li>
                        Obtenez des milles de récompense Air Miles
                        <span style={{ fontSize: "50%", verticalAlign: "top" }}>
                          ®†
                        </span>{" "}
                        sur vos achats.
                        <a href={`${REDIRECT_SCP(REDIRECT_KEYS.airMiles)}`}>
                          En savoir plus sur le programme &gt;
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="h-cont-footer-box">
                  <div
                    class="v-container"
                    style={{ minHeight: "90px", minWidth: "170px" }}
                  >
                    <span>Joignez-nous sur :</span>
                    <ul>
                      <li>
                        {/* <li>img line</li>  */}
                        <div style={{ height: "36.72px" }}>
                          <div
                            class="footer-mini-images-container"
                            style={{ height: "27px" }}
                          >
                            <a href="http://www.youtube.com/staplestechtv">
                              <img src={YoutubeIcon} alt="YouTube" />
                            </a>
                          </div>
                        </div>
                        <a href="https://www.staples.ca/sbdca/fr_CA/cre/programs/email/index.html?icid=HP:HP:STAPLESPRINTFOOTER:EmailSignup:RESP::1">
                          <p>Aubaines! Profitez-en &gt;</p>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </footer>
          <div
            style={{
              maxWidth: "930px",
              marginLeft: "auto",
              marginRight: "auto"
            }}
          >
            <div class="fineprint">{finePrint} </div>
          </div>
        </div>
      );
    }
  } else {
    return null;
  }
}

export default Footer;
